import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Button, Card } from "react-bootstrap";
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

export const ContactSec = () => {
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="banner-content">
            <h2>Contact Us</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Contact Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <section className="contact-sec pb-0 pt-5 py-lg-5">
        <div className="container">
          <div className="row contact-row flex-lg-row flex-column-reverse">
            <div className="col-lg-5 mb-5 mb-lg-0">
              <h2>Other ways to connect</h2>
              <Card>
                <div className="connect-icon">
                  <div>
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                </div>
                <div className="connect-content">
                  <h4>Contact</h4>
                  <Link to="tel:+91 9016501095">+91 9016501095</Link>
                </div>
              </Card>
              <Card>
                <div className="connect-icon">
                  <div>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                </div>
                <div className="connect-content">
                  <h4>Email</h4>
                  <Link to="mailto:contact@codeinfoway.com">
                    contact@codeinfoway.com
                  </Link>
                </div>
              </Card>
              <Card>
                <div className="connect-icon">
                  <div>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </div>
                </div>
                <div className="connect-content">
                  <h4>Address</h4>
                  <p>
                    407, Gravity Retail & Work Spaces, MG Road, Nikol,
                    Ahmedabad, Gujarat 380038.
                  </p>
                </div>
              </Card>
              <h2>Socialize with us</h2>
              <ul className="social-icons-list">
                <li>
                  <Link to="https://www.facebook.com/profile.php?id=61570993910963">
                    <FontAwesomeIcon icon={faFacebook} />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.linkedin.com/company/codeinfoway/">
                    <FontAwesomeIcon icon={faTwitter} />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <FontAwesomeIcon icon={faInstagram} />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/channel/UCdpm8DEMicNuL-ssjQfqEPA">
                    <FontAwesomeIcon icon={faYoutube} />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="form-box">
                <h2>Get in touch with us</h2>
                <Card className="p-0 border-0">
                  <Form className="w-100">
                    <div className="row">
                      <div className="mb-3 col-lg-12">
                        <Form.Label>
                          Full Name<sup>*</sup>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Full Name"
                          required
                        />
                      </div>
                      <div className="mb-3 col-lg-6">
                        <Form.Label>
                          Email<sup>*</sup>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email Address"
                          required
                        />
                      </div>
                      <div className="mb-3 col-lg-6">
                        <Form.Label>
                          Contact Number<sup>*</sup>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Contact Number"
                          required
                        />
                      </div>
                      <div className="mb-3 col-lg-12">
                        <Form.Label>
                          Subject<sup>*</sup>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Subject"
                          required
                        />
                      </div>
                      <div className="mb-3 col-lg-12">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Enter Message..."
                          rows={3}
                        />
                      </div>
                      <div className="col-12">
                        <Button type="submit" variant="primary">
                          Submit
                        </Button>
                      </div>
                    </div>
                  </Form>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="title mb-4">
            <h2 className="text-center">Find Us on Google Maps</h2>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.332805799448!2d72.67052777509262!3d23.0482572791558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e876284960a09%3A0x2cc31e23fd49bcb4!2sCodeInfoWay!5e0!3m2!1sen!2sin!4v1736336341390!5m2!1sen!2sin"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </>
  );
};
